import initialState from './ReportInitialState';
import reducers from './ReportReducer';

export default {
  initialState,
  reducers,
};
